import React, { useState } from "react";
import GlobalLoader from "../shared/GlobalLoader";
import SuccessPopup from "../shared/SuccessPopup";
import { useLoading } from "../../context/LoadingContext";

const Contact = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  // State to hold the form input values
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    emailAddress: "",
    phone: "",
    message: "",
    company: "",
  });
  const { isLoading, setLoading } = useLoading();
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const [infoMessage, setInfoMessage] = useState("");
  const [showSuccessPopup, setShowSuccessPopup] = useState({
    type: "",
    show: false,
    message: ""
  });

  // Handle form input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    const accessToken = sessionStorage.getItem("accessToken");
    e.preventDefault();
    setLoading(true);
    const headers = {
      Authorization: accessToken ? `${accessToken}` : "",
      "Content-Type": "application/json",
    };
    try {
      const response = await fetch(`${baseUrl}/contact`, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(formData),
      });
      const result = await response.json();

      if (result?.status === 'success') {
        setLoading(false);
        setShowSuccessPopup({
          type: "success",
          show: true,
          message: result?.message || "Form submitted successfully",
        });
        setInfoModalOpen(true);
        setInfoMessage("Form submitted successfully!");
        setFormData({
          firstName: "",
          lastName: "",
          emailAddress: "",
          phone: "",
          message: "",
          company: "",
        });
      } else {
        setShowSuccessPopup({
          type: "warning",
          show: true,
          message: result?.message || "Failed to submit the form",
        });
        setInfoModalOpen(true);
        setInfoMessage("Failed to submit the form.");
        setLoading(false);
      }
    } catch (error) {
      console.error("Request failed:", error);
      setInfoModalOpen(true);
      setInfoMessage("Something went wrong. Please try again later.");
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid mt-3">
      {isLoading && <GlobalLoader />}
      <div className="row px-2">
        <div className="col-6">
          <div className="theme-container rounded shadow py-2 px-4 min-height-520">
            <div className="contact-page-heading">
              <div className="text-center fnt14 fw-600">Connect with us to learn more about our industrial refrigeration services and opportunities to partner together.</div>
            </div>
            <hr className="mt-0" />
            <div className="mt-4">
              <form onSubmit={handleSubmit}>
                <div className="row mb-2 mt-3">
                  <div className="col">
                    <label htmlFor="firstName" className="form-label fnt12 fw-500">
                      First Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="firstName"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleInputChange}
                      placeholder=""
                    />
                  </div>
                  <div className="col">
                    <label htmlFor="lastName" className="form-label fnt12 fw-500">
                      Last Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="lastName"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleInputChange}
                      placeholder=""
                    />
                  </div>
                </div>

                <div className="row mb-2">
                  <div className="col">
                    <label htmlFor="company" className="form-label fnt12 fw-500">
                      Company
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="company"
                      name="company"
                      value={formData.company}
                      onChange={handleInputChange}
                      placeholder=""
                    />
                  </div>
                </div>

                <div className="row mb-2">
                  <div className="col">
                    <label htmlFor="emailAddress" className="form-label fnt12 fw-500">
                      Email
                    </label>
                    <div className="input-group">
                      <span className="input-group-text" id="basic-addon1">
                        <i class="bi bi-envelope"></i>
                      </span>
                      <input
                        type="email"
                        className="form-control left-border"
                        id="emailAddress"
                        name="emailAddress"
                        value={formData.emailAddress}
                        onChange={handleInputChange}
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div className="col">
                    <label htmlFor="phone" className="form-label fnt12 fw-500">
                      Phone
                    </label>
                    <div className="input-group">
                      <span className="input-group-text" id="basic-addon1">
                        <i class="bi bi-telephone"></i>
                      </span>
                      <input
                        type="tel"
                        className="form-control left-border"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        onKeyDown={(e) => {
                          if (e.ctrlKey && (e.key === 'v' || e.key === 'c' || e.key === 'x')) {
                            return; // Allow these key combinations
                          }

                          // Allow: numbers, +, -, (, ), space, and special keys
                          if (
                            !(
                              (e.key >= '0' && e.key <= '9') ||
                              e.key === '+' ||
                              e.key === '-' ||
                              e.key === '(' ||
                              e.key === ')' ||
                              e.key === ' ' ||
                              e.key === 'Backspace' ||
                              e.key === 'Delete' ||
                              e.key === 'ArrowLeft' ||
                              e.key === 'ArrowRight' ||
                              e.key === 'Tab'
                            )
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onPaste={(e) => {
                          // Optional: Validate pasted content
                          const pasteData = e.clipboardData.getData('text');
                          if (!/^[\d+\-() ]*$/.test(pasteData)) {
                            e.preventDefault();
                          }
                        }}
                        placeholder=""
                      />
                    </div>
                  </div>

                </div>

                <div className="mb-2">
                  <label htmlFor="message" className="form-label fnt12 fw-500">
                    Message
                  </label>
                  <textarea
                    className="form-control"
                    id="message"
                    name="message"
                    rows="4"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder=""
                  ></textarea>
                </div>

                <div className="d-flex align-items-center justify-content-center pt-3">
                  <button type="submit" className="button-primary py-2 px-3 fw-500">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div className="col-6">
          <div className="theme-container rounded shadow py-2 px-4 min-height-520">
            <div className="contact-page-heading">
              <div className="text-center fnt14 fw-600">HEADQUARTERS</div>
            </div>
            <hr className="mt-0" />
            <div className="row px-3 mb-4">
              <div className="col-6">
                <div className="contact-company-heading">Cold Core Group</div>
                <div className="mt-3 ms-1">
                  <div className="d-flex align-items-center pb-1">
                    <span className="headquarters-icons" id="basic-addon1">
                      <i class="bi bi-telephone-fill"></i>
                    </span>
                    <span className="headquarters-details">(262) 781-5757</span>
                  </div>
                  <div className="d-flex align-items-center pb-1">
                    <span className="headquarters-icons" id="basic-addon1">
                      <i class="bi bi-envelope-fill"></i>
                    </span>
                    <span className="headquarters-details">info@coldcoregroup.com</span>
                  </div>
                  <div className="d-flex align-items-center pb-1">
                    <span className="headquarters-icons" id="basic-addon1">
                      <i class="bi bi-geo-alt-fill"></i>
                    </span>
                    <span className="headquarters-details">W141 N9501 Fountain Blvd.<br />
                      Menomonee Falls, WI 53051</span>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="contact-company-heading" >Summit Refrigeration</div>
                <div className="mt-3 ms-1">
                  <div className="d-flex align-items-center pb-1">
                    <span className="headquarters-icons" id="basic-addon1">
                      <i class="bi bi-telephone-fill"></i>
                    </span>
                    <span className="headquarters-details">(262) 781-5757</span>
                  </div>
                  <div className="d-flex align-items-center pb-1">
                    <span className="headquarters-icons" id="basic-addon1">
                      <i class="bi bi-envelope-fill"></i>
                    </span>
                    <span className="headquarters-details">
                      info@summitrefrig.com</span>
                  </div>
                  <div className="d-flex align-items-center pb-1">
                    <span className="headquarters-icons" id="basic-addon1">
                      <i class="bi bi-globe"></i>
                    </span>
                    <span className="headquarters-details">summitrefrig.com</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="row px-3 mb-5">
              <div className="col-6">
                <div className="contact-company-heading">All Temp Refrigeration</div>
                <div className="mt-3 ms-1">
                  <div className="d-flex align-items-center pb-1">
                    <span className="headquarters-icons" id="basic-addon1">
                      <i class="bi bi-telephone-fill"></i>
                    </span>
                    <span className="headquarters-details">
                      (319) 362-8367</span>
                  </div>
                  <div className="d-flex align-items-center pb-1">
                    <span className="headquarters-icons" id="basic-addon1">
                      <i class="bi bi-envelope-fill"></i>
                    </span>
                    <span className="headquarters-details">
                      info@alltempcr.com</span>
                  </div>
                  <div className="d-flex align-items-center pb-1">
                    <span className="headquarters-icons" id="basic-addon1">
                      <i class="bi bi-globe"></i>
                    </span>
                    <span className="headquarters-details">alltempcr.com</span>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="contact-company-heading" >Fore-Front Mechanical</div>
                <div className="mt-3 ms-1">
                  <div className="d-flex align-items-center pb-1">
                    <span className="headquarters-icons" id="basic-addon1">
                      <i class="bi bi-telephone-fill"></i>
                    </span>
                    <span className="headquarters-details">
                      (715) 241-0110</span>
                  </div>
                  <div className="d-flex align-items-center pb-1">
                    <span className="headquarters-icons" id="basic-addon1">
                      <i class="bi bi-envelope-fill"></i>
                    </span>
                    <span className="headquarters-details">
                      info@ffmech.com</span>
                  </div>
                  <div className="d-flex align-items-center pb-1">
                    <span className="headquarters-icons" id="basic-addon1">
                      <i class="bi bi-globe"></i>
                    </span>
                    <span className="headquarters-details">
                      ffmech.com</span>
                  </div>
                </div>
              </div>
            </div>
            <hr className="mt-0" />
            <div className="fnt14 fw-600 text-center my-2">Branch Offices</div>
            <div className="d-flex align-items-center justify-content-between my-3">
              <div className="countries-names">
                <span className="country-icon" id="basic-addon1">
                  <i class="bi bi-geo-alt-fill"></i>
                </span>&nbsp;Des Moines, IA</div>
              <div className="countries-names"><span className="country-icon" id="basic-addon1">
                <i class="bi bi-geo-alt-fill"></i>
              </span>&nbsp;Springdale, AR</div>
              <div className="countries-names"><span className="country-icon" id="basic-addon1">
                <i class="bi bi-geo-alt-fill"></i>
              </span>&nbsp;Louisville, KY</div>
              <div className="countries-names"><span className="country-icon" id="basic-addon1">
                <i class="bi bi-geo-alt-fill"></i>
              </span>&nbsp;Raleigh, NC</div>
              <div className="countries-names"><span className="country-icon" id="basic-addon1">
                <i class="bi bi-geo-alt-fill"></i>
              </span>&nbsp;Birmingham, AL</div>
            </div>
          </div>

        </div>
      </div>

      <SuccessPopup
        type={showSuccessPopup?.type}
        show={showSuccessPopup?.show}
        message={showSuccessPopup?.message}
        onClose={() => setShowSuccessPopup(false)}
      />
    </div>
  );
};

export default Contact;
